const setting = {
  passwordTitle: "Password",
  changePasswordBtn: "Change Password",
  changePasswordTips:
    "If you forget your password or want to change it, you can do so here; we will send a verification code to your registered e-mail address, which is to be verified to confirm your identity, and then you can reset your account password.",
  feedbackTitle: "Feedback",
  feedbackBtn: "Submit Feedback",
  feedbackTips:
    "In order for us to serve you better, you can describe your problem here and submit it to us for feedback, and our customer service team will contact you as soon as possible.",
  appearanceTitle: "Appearance Display",
  appearanceBtn: "Change Display",
  appearanceTips: "We choose two appearance modes for you, so you can switch between dark and light modes according to your preference.",
  changePassWordModalTitle: "Change Password",
  changePassWordSameErrorTips: "The new password you entered is the same as your old password. Enter a different password",
  changePasswordCurrentErrorTips: "Your password was incorrect. Please try again.",
  currentPasswordLabel: "Current password",
  newPasswordLabel: "New password",
  retypePasswordLabel: "Retype new password",
  changePasswordSuccessTips: "Your password has been changed successfully.",
  changePasswordComfirmDiffErrorTips: "Please enter the same password in both fields.",
  forgotPassword: "Forgot Password?",
  feedbackModalSubtitle: "Thank you for contacting us and telling us your opinion on the product!",
  feedBackModalProductQuestion: "What kind of problems do you want to solve with our product",
  feedBackModalProductTypeSug: "Suggestions",
  feedBackModalProductTypeMem: "Member service related questions",
  feedBackModalProductTypeFun: "Function inquiry",
  feedBackModalProductTypeReq: "Product Requirements",
  feedBackModalProductTypeBug: "Feedback on product bugs",
  feedBackModalProductTypeIss: "Performance Issues",
  feedBackModalProductTypeRL: "Registration and login related questions",
  feedBackModalProductTypeRef: "Refund Service",
  feedBackModalProductTypeOth: "Others",
  feedBackModalProductSelectQuestion: "What kind of problems do you want to solve with our product",
  feedBackModalProductContQuestion: "What’s problem did you encounter when using the product?",
  feedBackModalAddImageBtn: "Add images",
  feedBackModalTips: "Tips:",
  feedBackModalTipsCont: "Due to the time difference of the global customer service, we will reply you within 48 hours of the working day;",
  feedBackSuccessTips: "Send successfully",
  feedBackSuccessSubTips: "We will solve your problem as soon as possible",
  feedBackFailedTips: "Failed to send",
  feedBackFailedSubTips: "Please make sure your network connection is working and submit again",
  appearanceLightMode: "Light mode",
  appearanceDarkMode: "Dark mode",
  promotionModalTitle: "Promotion",
  promoItem: "Promo item",
  promoCode: "Promo Code",
  discount: "Discount",
  applyBtn: "Apply",
  applyPromotionErrorTips: "Your promo code is invalid",
};

export default setting;
